import request from '../../../../../../api/request';
import { SearchParams } from '../types/Filters';
import { ResponseAdminAccounts } from '../types/Users';

const USERS = {
  GET_ADMIN_ACCOUNT_LIST: '/maintainers-portal/admin-account',
  GET_ADMIN_ACCOUNT_DOWNLOAD: '/maintainers-portal/admin-account/download',
  PUT_ADMIN_ACCOUNT_STATUS: (accountId: number | string) =>
    `/maintainers-portal/admin-account/${accountId}`,
};

/**
 * Obtiene el listado de las usuarios de tipo administrador
 * @param items
 * @param page
 * @returns
 */
export function getAdminAccountList(
  filter: { items: number; page: number } & SearchParams,
) {
  const URL = USERS.GET_ADMIN_ACCOUNT_LIST;
  const method = 'GET';
  const params = { ...filter, items_per_page: filter.items };
  return request<ResponseAdminAccounts>(URL, { method, params });
}

/**
 * Descarga el listado de usuarios administrativos en Excel, con la columna de
 * estado (habilitado/deshabilitado). Respeta los filtros de la búsqueda.
 */
export function downloadAdminAccountList(filter: SearchParams) {
  const URL = USERS.GET_ADMIN_ACCOUNT_DOWNLOAD;
  const method = 'GET';
  const params = {
    search: filter.search,
    email: filter.email,
    roleId: filter.roleId,
  };
  return request<Blob>(URL, { method, params, responseType: 'blob' });
}
